import * as React from "react"
import { SVGProps } from "react"
const StromIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 520" {...props}>
        <path
            d="M464 290c-33 0-66 1-99-2-10-4-19-13-20-24-3-31-1-62 1-93 0-13 11-25 24-26 31-3 63-1 94-1 1 0 3 1 3 2 1 48-1 95-1 143a3.49 3.49 0 0 1-2 1Zm-87-142c-13 1-26 10-27 23-1 24 0 47-2 71 0 7 0 15 1 22 2 9 9 14 16 19 32 4 65 1 97 2-2-16-1-31-1-47 1-26 2-53 2-79 0-3-1-7-1-10-28 0-57 0-85-1Z"
            className="a"
        />
        <path
            d="M464 290c-33 0-66 1-99-2-10-4-19-13-20-24-3-31-1-62 1-93 0-13 11-25 24-26 31-3 63-1 94-1 1 0 3 1 3 2 1 48-1 95-1 143a3.49 3.49 0 0 1-2 1Zm-87-142c-13 1-26 10-27 23-1 24 0 47-2 71 0 7 0 15 1 22 2 9 9 14 16 19 32 4 65 1 97 2-2-16-1-31-1-47 1-26 2-53 2-79 0-3-1-7-1-10-28 0-57 0-85-1Z"
            className="b"
        />
        <path
            d="M464 316c-5-18-4-37-4-55 0-19 0-39 2-58 2-22 2-43 2-65-3-5 1-11-2-17-1-2 3-4 3-3 8 65 0 129 0 194 0 0 2 4-1 4Z"
            className="a"
        />
        <path
            d="M464 316c-5-18-4-37-4-55 0-19 0-39 2-58 2-22 2-43 2-65-3-5 1-11-2-17-1-2 3-4 3-3 8 65 0 129 0 194 0 0 2 4-1 4Z"
            className="b"
        />
        <path
            d="M542 191c-26 1-52-3-78-1a2.15 2.15 0 0 1-2-2c1-7-3-16 2-21 25-3 49 1 74 1 2 0 3-1 5-1 3 1 6 1 8 3s2 5 3 8c1 7-6 11-12 13Zm-75-6c25-3 50 2 75 1 4 0 6-3 7-7 0-2 0-5-3-6-27-3-53-2-79-2v14Z"
            className="a"
        />
        <path
            d="M542 191c-26 1-52-3-78-1a2.15 2.15 0 0 1-2-2c1-7-3-16 2-21 25-3 49 1 74 1 2 0 3-1 5-1 3 1 6 1 8 3s2 5 3 8c1 7-6 11-12 13Zm-75-6c25-3 50 2 75 1 4 0 6-3 7-7 0-2 0-5-3-6-27-3-53-2-79-2v14Z"
            className="b"
        />
        <path
            d="M542 267c-24 2-49-2-73-1-2 0-4 1-5 1-5-6-2-16-1-23 27-3 55 0 82 0 5 1 8 5 9 10 0 7-4 14-12 13Zm-75-5c25-3 50 2 75 1 4 0 6-3 7-7 0-2 0-5-3-6-27-3-53-2-79-2v14Z"
            className="a"
        />
        <path
            d="M542 267c-24 2-49-2-73-1-2 0-4 1-5 1-5-6-2-16-1-23 27-3 55 0 82 0 5 1 8 5 9 10 0 7-4 14-12 13Zm-75-5c25-3 50 2 75 1 4 0 6-3 7-7 0-2 0-5-3-6-27-3-53-2-79-2v14Z"
            className="b"
        />
        <path
            d="M424 194c-3-2-7 0-9-3l-3-3c-6-10-2-22 10-25 6-1 12 1 15 6 4 7 4 16-2 21-3 2-6 4-11 4Zm1-26c-6-1-10 4-11 9a18.84 18.84 0 0 0 2 8l3 3c4 2 9 2 12-1a16.12 16.12 0 0 0 4-7c0-6-3-13-10-12Z"
            className="a"
        />
        <path
            d="M424 194c-3-2-7 0-9-3l-3-3c-6-10-2-22 10-25 6-1 12 1 15 6 4 7 4 16-2 21-3 2-6 4-11 4Zm1-26c-6-1-10 4-11 9a18.84 18.84 0 0 0 2 8l3 3c4 2 9 2 12-1a16.12 16.12 0 0 0 4-7c0-6-3-13-10-12Z"
            className="b"
        />
        <path
            d="M424 271c-3-2-7 0-9-3l-3-3c-5-7-3-18 4-23 6-3 13-3 18 1 8 6 7 17 1 24-3 3-7 3-11 4Zm1-26c-6-1-10 4-11 9-1 7 4 10 10 12 3 1 5-1 7-2a16.12 16.12 0 0 0 4-7c0-6-3-13-10-12Z"
            className="a"
        />
        <path
            d="M424 271c-3-2-7 0-9-3l-3-3c-5-7-3-18 4-23 6-3 13-3 18 1 8 6 7 17 1 24-3 3-7 3-11 4Zm1-26c-6-1-10 4-11 9-1 7 4 10 10 12 3 1 5-1 7-2a16.12 16.12 0 0 0 4-7c0-6-3-13-10-12Z"
            className="b"
        />
        <path
            d="M347 234c-10 0-20-3-30-3-4-8-1-17-2-26a2.15 2.15 0 0 1 2-2 170.9 170.9 0 0 1 31-3c2 11 1 21 1 32 0 1-1 1-2 2Zm-28-8c8 1 17 3 25 3-1-8 1-16 1-24-8 1-17 1-25 2 0 6 1 13-1 19Z"
            className="a"
        />
        <path
            d="M347 234c-10 0-20-3-30-3-4-8-1-17-2-26a2.15 2.15 0 0 1 2-2 170.9 170.9 0 0 1 31-3c2 11 1 21 1 32 0 1-1 1-2 2Zm-28-8c8 1 17 3 25 3-1-8 1-16 1-24-8 1-17 1-25 2 0 6 1 13-1 19Z"
            className="b"
        />
        <path
            d="M390 290c-4-3-2-7-2-11-3-17 3-34 0-51 0-1 0-3 1-4h2c4 3 2 8 2 12 3 18-1 35-1 53a3.49 3.49 0 0 1-2 1Z"
            className="a"
        />
        <path
            d="M390 290c-4-3-2-7-2-11-3-17 3-34 0-51 0-1 0-3 1-4h2c4 3 2 8 2 12 3 18-1 35-1 53a3.49 3.49 0 0 1-2 1Z"
            className="b"
        />
        <path
            d="M372 289h-2c-3-7-1-15-1-22 1-3 1-6 0-10a3.19 3.19 0 0 1 3-3c1 0 2 2 2 3v30c0 1 0 2-2 2Z"
            className="a"
        />
        <path
            d="M372 289h-2c-3-7-1-15-1-22 1-3 1-6 0-10a3.19 3.19 0 0 1 3-3c1 0 2 2 2 3v30c0 1 0 2-2 2Z"
            className="b"
        />
        <path
            d="M317 215c-12-2-25-2-37-2-10 1-19 1-29 3-11 3-21 6-30 13a75.51 75.51 0 0 0-11 14 106.62 106.62 0 0 0-7 19c-2 8-2 15-3 23-1 30-2 60 1 90h4c2-32-1-63 1-95 0-11 4-21 6-31 21-38 70-30 107-30a3.49 3.49 0 0 0 1-2c0-1 0-2-3-2Z"
            className="a"
        />
        <path
            d="M317 215c-12-2-25-2-37-2-10 1-19 1-29 3-11 3-21 6-30 13a75.51 75.51 0 0 0-11 14 106.62 106.62 0 0 0-7 19c-2 8-2 15-3 23-1 30-2 60 1 90h4c2-32-1-63 1-95 0-11 4-21 6-31 21-38 70-30 107-30a3.49 3.49 0 0 0 1-2c0-1 0-2-3-2Z"
        />
        <path
            d="M296 190h-16c-14 0-28 2-43-1-1 0-1-1-1-2 3-4 8-2 12-2 17-3 33 2 50 1a3.49 3.49 0 0 1 1 2c0 1-2 2-3 2Z"
            className="a"
        />
        <path
            d="M296 190h-16c-14 0-28 2-43-1-1 0-1-1-1-2 3-4 8-2 12-2 17-3 33 2 50 1a3.49 3.49 0 0 1 1 2c0 1-2 2-3 2Z"
            className="b"
        />
        <path
            d="M297 253c-10-1-21 2-31-1a3.49 3.49 0 0 1-1-2c0-1 2-2 3-2 10 0 19-1 29 0 2 1 2 3 0 5Z"
            className="a"
        />
        <path
            d="M297 253c-10-1-21 2-31-1a3.49 3.49 0 0 1-1-2c0-1 2-2 3-2 10 0 19-1 29 0 2 1 2 3 0 5Z"
            className="b"
        />
    </svg>
)
export default StromIcon

